<template>
    <div class="map">
        <GoldMine ref="goldmine" class="map__gold-mine"></GoldMine>
        <Forest ref="forest" class="map__forest"></Forest>
        <TownHall ref="townhall" class="map__townhall"></TownHall>
        <Blacksmith class="map__blacksmith"></Blacksmith>
        <Farm class="map__farm"></Farm>

        <GoldMiner class="workers__peon workers__peon--gold" 
            v-for="(worker, index) in $store.state.goldWorkers" 
            :key="'gold' + index"
            :to="mine"
            :from="townhall"
            :percent="worker.percent">
        </GoldMiner>

        <WoodChopper class="workers__peon workers__peon--wood" 
            v-for="(worker, index) in $store.state.woodWorkers" 
            :key="'wood' + index"
            :to="forest"
            :from="townhall"
            :percent="worker.percent">
        </WoodChopper>
    </div>
</template>

<script>
    import GoldMine from "@/components/buildings/GoldMine"
    import Forest from "@/components/buildings/Forest"
    import TownHall from "@/components/buildings/TownHall"
    import Blacksmith from "@/components/buildings/Blacksmith"
    import Farm from "@/components/buildings/Farm"
    import GoldMiner from "@/components/GoldMiner"
    import WoodChopper from "@/components/WoodChopper"

    export default {
        name: "Map",
        components: {
            GoldMine,
            Forest,
            TownHall,
            Blacksmith,
            Farm,
            GoldMiner,
            WoodChopper,
        },
        data() {
            return {
                mine: undefined,
                forest: undefined,
                townhall: undefined,
            }
        },
        mounted() {
            this.mine = this.$refs.goldmine.$el.getBoundingClientRect()
            this.forest = this.$refs.forest.$el.getBoundingClientRect()
            this.townhall = this.$refs.townhall.$el.getBoundingClientRect()
        }
        
    }
</script>

<style lang="scss" scoped>

    .map {
        //background: theme('colors.orange.800');
        background: url('../assets/images/ground_tile_small.png') repeat;
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-template-rows: repeat(5, 1fr);
        grid-column-gap: 0px;
        grid-row-gap: 0px;

        > div {
            @apply flex items-center justify-center font-bold;
        }

        &__townhall { 
            grid-area: 4 / 3 / 6 / 5; 
        }
        
        &__blacksmith { 
            grid-area: 4 / 1 / 5 / 2; 
        }

        &__farm { 
            grid-area: 5 / 6 / 6 / 7; 
        }

        &__gold-mine { 
            grid-area: 1 / 2 / 2 / 3; 
        }

        &__forest { 
            grid-area: 1 / 5 / 2 / 6; 
        }
    }
</style>